import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class CeOverlayContainerService {
    #overlayContainers: HTMLDivElement[] = [];

    createOverlayContainer(className: string): HTMLDivElement {
        this.#clearEmptyCdkOverlayContainers();

        const overlayContainer = document.createElement('div');
        overlayContainer.classList.add(className);
        document.body.appendChild(overlayContainer);
        this.#overlayContainers.push(overlayContainer);
        return overlayContainer;
    }

    createOverlayContainerWithinContainer(containerData: { className: string; container: string }): HTMLDivElement {
        this.#clearEmptyCdkOverlayContainers();

        const targetContainer = document.querySelector(containerData.container);
        if (!targetContainer) {
            throw new Error(
                `Cannot create overlay container: target container "${containerData.container}" not found in the DOM`
            );
        }

        const overlayContainer = document.createElement('div');
        overlayContainer.classList.add(containerData.className);
        targetContainer.appendChild(overlayContainer);
        this.#overlayContainers.push(overlayContainer);
        return overlayContainer;
    }

    removeOverlayContainer(overlayContainer: HTMLDivElement | null): void {
        if (!overlayContainer) return;

        // Check if the overlay container has a parent node and remove it from that parent
        if (overlayContainer.parentNode) {
            overlayContainer.parentNode.removeChild(overlayContainer);
            const index = this.#overlayContainers.indexOf(overlayContainer);
            if (index > -1) {
                this.#overlayContainers.splice(index, 1);
            }
        }
    }

    /**
     * This is a workaround to remove the cdk-overlay-container elements that are not removed by Angular.
     * These elements are automatically created by Angular CDK Overlay when a component is attached to the overlay.
     *
     * This method should be called before creating a new overlay container, as we create a new descriptive overlay container for each overlay.
     */
    #clearEmptyCdkOverlayContainers() {
        const cdkOverlayContainers = document.querySelectorAll('.cdk-overlay-container');
        cdkOverlayContainers.forEach((container) => {
            container.remove();
        });
    }
}
